import React from 'react';
import { SvgIconProps } from '@material-ui/core';

const BigApp: React.FC<SvgIconProps> = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_12_2028)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 25.8532V6.14605C32 2.76505 29.2342 0 25.854 0H6.14605C2.76607 0 0 2.7653 0 6.14605V25.8532C0 29.2339 2.76581 32 6.14605 32H25.854C29.2339 32 32 29.2339 32 25.8532Z"
        fill="url(#paint0_linear_12_2028)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.23709 28.2349H24.757C26.7905 28.2349 28.438 26.5859 28.438 24.5531V12.4769C28.438 11.1612 27.737 9.94583 26.5973 9.28822L17.8383 4.23107C17.2686 3.90214 16.6328 3.73755 15.9976 3.73755C15.3615 3.73755 14.7258 3.90214 14.1566 4.23107L5.39711 9.28822C4.25741 9.94583 3.5556 11.1612 3.5556 12.4769V24.5531C3.5556 26.5862 5.20534 28.2349 7.23734 28.2349H7.23709Z"
        fill="url(#paint1_linear_12_2028)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8089 3.81214C14.2925 3.97673 13.8539 4.27594 13.4063 4.52334L8.01948 7.60513L5.33698 9.16571C4.40657 9.70089 3.72738 10.646 3.51478 11.6956C3.40124 12.2267 3.44467 12.7558 3.43934 13.266L3.44594 14.8177L3.45813 17.9216L3.48277 24.1281C3.47871 24.6387 3.50081 25.1825 3.6748 25.6785C3.8399 26.1771 4.11142 26.6379 4.46398 27.0225C5.16578 27.7977 6.19906 28.2521 7.23665 28.2345C6.19906 28.2279 5.18635 27.7509 4.51757 26.975C4.18102 26.5891 3.92702 26.1335 3.77818 25.6465C3.61917 25.1548 3.61104 24.6478 3.62705 24.1281L3.65321 17.9216L3.66515 14.8177L3.67124 13.266C3.68064 12.7456 3.64381 12.2305 3.75405 11.7448C3.96156 10.7654 4.60165 9.88961 5.47261 9.39939L8.16578 7.85811L13.5285 4.73365C13.9829 4.47737 14.4076 4.18501 14.8818 4.03261C15.3573 3.87742 15.8666 3.81366 16.3657 3.8665C17.385 3.93279 18.2252 4.60919 19.1368 5.09281L24.5249 8.17307L25.8777 8.93355C26.3253 9.19365 26.7972 9.41387 27.1813 9.75372C27.9573 10.4261 28.4297 11.4395 28.4376 12.4764C28.4536 11.4403 28.0042 10.404 27.229 9.70038C26.8424 9.34326 26.3695 9.11034 25.9313 8.84084L24.5968 8.05014L19.2346 4.92415L17.8943 4.14285C17.4332 3.87793 16.9181 3.70393 16.3885 3.64983C16.2539 3.63383 16.118 3.62646 15.9832 3.62646C15.5856 3.62646 15.1884 3.69174 14.8092 3.81163L14.8089 3.81214Z"
        fill="url(#paint2_linear_12_2028)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.3253 21.3211L28.3111 23.5319C28.2984 24.2738 28.3647 25.0102 28.1186 25.68C27.6756 27.0391 26.3424 28.0399 24.9189 28.0808L16.081 28.123C13.1331 28.1425 10.1844 28.1811 7.23645 28.2355C10.1844 28.2891 13.1331 28.3285 16.081 28.3473L24.9324 28.3734C26.475 28.3219 27.9045 27.2294 28.3721 25.7651C28.4851 25.4019 28.5633 25.0234 28.5641 24.6411L28.5649 23.5322L28.5514 21.3213C28.5313 18.3734 28.492 15.4262 28.4376 12.4773C28.3835 15.426 28.3447 18.3734 28.3253 21.3213V21.3211Z"
        fill="url(#paint3_linear_12_2028)"
      />
      <path
        d="M10.3833 19.4751H8.63402C8.53165 19.4751 8.44961 19.3928 8.44961 19.2912V17.6324H10.3231C11.269 17.6324 11.6884 17.9796 11.6884 18.5414C11.6884 19.1884 11.1974 19.4754 10.3833 19.4754V19.4751ZM8.44961 14.513C8.44961 14.4114 8.53165 14.3291 8.63402 14.3291H10.012C10.79 14.3291 11.2215 14.6395 11.2215 15.1907C11.2215 15.8366 10.7064 16.1002 9.8931 16.1002H8.44961V14.513ZM11.9528 16.7106C12.5507 16.3753 13.0544 15.8488 13.0544 14.9031C13.0544 13.3319 11.6851 12.7131 10.2868 12.7131H6.96041C6.79048 12.7131 6.65332 12.8508 6.65332 13.0207V20.7837C6.65332 20.9537 6.79073 21.0916 6.96041 21.0916H10.3833C12.2756 21.0916 13.5212 20.3258 13.5212 18.7931C13.5212 17.6446 12.9226 17.0819 11.9528 16.7108V16.7106Z"
        fill="white"
      />
      <path
        d="M16.1134 12.7127H14.7609C14.6585 12.7127 14.5762 12.7957 14.5762 12.8973V20.9062C14.5762 21.0086 14.6585 21.0909 14.7609 21.0909H16.1134C16.2834 21.0909 16.421 20.9529 16.421 20.783V13.02C16.4205 12.8501 16.2834 12.7124 16.1134 12.7124V12.7127Z"
        fill="white"
      />
      <path
        d="M25.1558 16.2473H21.8548C21.7532 16.2473 21.6701 16.3296 21.6701 16.4312V17.5224C21.6701 17.6923 21.808 17.83 21.978 17.83H22.1017C22.1042 17.83 22.1075 17.8315 22.1111 17.8315H22.2127V17.8307C22.5586 17.8315 23.2723 17.8315 23.6262 17.8307V18.9819C23.1667 19.2948 22.5634 19.4721 21.9531 19.4721C20.5177 19.4721 19.5149 18.4152 19.5149 16.9021C19.5149 15.4668 20.5322 14.3423 21.8306 14.3423C22.6815 14.3423 23.1918 14.5912 23.6798 14.9684C23.6884 14.975 23.7405 15.0154 23.8007 15.0621C23.9132 15.1477 24.0742 15.1244 24.157 15.0098C24.1934 14.9598 24.2282 14.9107 24.2548 14.8739C24.4138 14.656 24.79 14.1421 24.79 14.1421C24.79 14.1421 24.8329 14.0832 24.8855 14.009C24.9653 13.8993 24.9419 13.7454 24.8342 13.6623C24.7511 13.5988 24.6942 13.5554 24.6823 13.5465C23.8728 12.9499 23.0321 12.6943 21.8863 12.6943C19.5335 12.6943 17.6904 14.5424 17.6904 16.9019C17.6904 19.3789 19.425 21.1089 21.9089 21.1089C23.4319 21.1089 24.539 20.4594 25.1921 19.9201C25.2843 19.8506 25.3399 19.7396 25.3399 19.6237V17.5221V16.6204V16.4312C25.3399 16.3296 25.2576 16.2473 25.1558 16.2473Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_12_2028"
        x1="42.8702"
        y1="48.0917"
        x2="3.89129"
        y2="1.53746"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F4A87" />
        <stop offset="0.109804" stopColor="#478BB2" />
        <stop offset="0.219608" stopColor="#1E4882" />
        <stop offset="0.588235" stopColor="#287BB9" />
        <stop offset="0.941176" stopColor="#70CCDD" />
        <stop offset="1" stopColor="#70CCDD" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12_2028"
        x1="-3.20183"
        y1="10.0589"
        x2="29.6585"
        y2="23.2031"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F4A87" />
        <stop offset="0.109804" stopColor="#428AB1" />
        <stop offset="0.219608" stopColor="#1E4882" />
        <stop offset="0.729412" stopColor="#287BB9" />
        <stop offset="0.988235" stopColor="#70CCDD" />
        <stop offset="1" stopColor="#66CADC" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_12_2028"
        x1="18.4449"
        y1="21.3082"
        x2="6.73373"
        y2="7.85735"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#287BB9" />
        <stop offset="0.690196" stopColor="#1E4882" />
        <stop offset="1" stopColor="#1F4A87" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_12_2028"
        x1="7.23721"
        y1="20.4247"
        x2="28.5651"
        y2="20.4247"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#70CCDD" />
        <stop offset="0.317647" stopColor="#8FD6E3" />
        <stop offset="0.670588" stopColor="white" />
        <stop offset="1" stopColor="#AFE0EA" />
      </linearGradient>
      <clipPath id="clip0_12_2028">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default BigApp;
